export default __webpack_public_path__ + "85039362e41d363b85e588edb3a05453.svg";